import React from 'react'

import styled from '@emotion/styled'

import { Box, Button, Text } from '@surglogs-app/ui'
import { FormFieldLabel } from '@surglogs-app/ui.form'

interface SecurityActionItemProps {
  label: string
  description: string
  buttonText: string
  innerContent?: React.ReactNode
  onButtonClick: () => void
}

const StyledBox = styled(Box)`
  &:last-of-type {
    margin-bottom: 0;
  }
`

export const SecurityActionItem = ({
  label,
  description,
  buttonText,
  innerContent,
  onButtonClick,
}: SecurityActionItemProps) => {
  return (
    <StyledBox {...{ mb: 'xl' }}>
      <Box>
        <FormFieldLabel>{label}</FormFieldLabel>
      </Box>
      <Box>
        <Text>{description}</Text>
      </Box>
      {innerContent ? (
        innerContent
      ) : (
        <Box>
          <Button {...{ onClick: onButtonClick, mt: 'md' }}>
            {buttonText}
          </Button>
        </Box>
      )}
    </StyledBox>
  )
}
